import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\GetMergeIntoListController::__invoke
* @see app/Http/Controllers/Invoice/GetMergeIntoListController.php
* @route '/api/invoicing/{invoice}/merge-into'
*/
const GetMergeIntoListController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMergeIntoListController.url(args, options),
    method: 'get',
})

GetMergeIntoListController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/merge-into',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\GetMergeIntoListController::__invoke
* @see app/Http/Controllers/Invoice/GetMergeIntoListController.php
* @route '/api/invoicing/{invoice}/merge-into'
*/
GetMergeIntoListController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return GetMergeIntoListController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\GetMergeIntoListController::__invoke
* @see app/Http/Controllers/Invoice/GetMergeIntoListController.php
* @route '/api/invoicing/{invoice}/merge-into'
*/
GetMergeIntoListController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMergeIntoListController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\GetMergeIntoListController::__invoke
* @see app/Http/Controllers/Invoice/GetMergeIntoListController.php
* @route '/api/invoicing/{invoice}/merge-into'
*/
GetMergeIntoListController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetMergeIntoListController.url(args, options),
    method: 'head',
})

export default GetMergeIntoListController